import React from 'react';
import cls from 'classnames';

export const ProgressRing = React.forwardRef(({
    className,
    classes,
	radius,
	stroke,
	progress,
	...props
}, ref) => {
    const rootRef = React.useRef();
	const [normalizedRadius, setNormalizedRadius] = React.useState(0);
	const [circumference, setCircumference] = React.useState(0);
	const [strokeDashoffset, setStrokeDashoffset] = React.useState(0);
	const [viewBox, setViewBox] = React.useState();
	
	React.useEffect(() => {
		setNormalizedRadius(radius - stroke * 2);
		setCircumference(normalizedRadius * 2 * Math.PI);
		setStrokeDashoffset(circumference - progress / 100 * circumference);
		const x = -((normalizedRadius / 2) + (stroke / 2));
		const w = (normalizedRadius * 2) + stroke;
		setViewBox([x, x, w, w].join(' '));
	}, [progress, radius, stroke, circumference, normalizedRadius]);

	React.useImperativeHandle(ref, () => ({
		root: rootRef.current,
	}));
	
	return (
		<svg
			{...props}
			ref={rootRef}
			className={cls(classes.root, className)}
			viewBox={viewBox}
			preserveAspectRatio={'xMinYMin meet'}
			height={'100%'}>
			<circle
				stroke='black'
				fill='transparent'
				strokeWidth={stroke}
				strokeDasharray={`${circumference} ${circumference}`}
				style={{strokeDashoffset}}
				r={normalizedRadius}
				cx={(normalizedRadius / 2)}
				cy={(normalizedRadius / 2)}
			/>
		</svg>
	);
});

export default ProgressRing;
